import { ActionReducer, IAction } from '@app/store';
import { XuxDndCacheActions } from '@app/store/actions/xux-dnd-cache/xux-dnd-cache.actions';
import { XuxDndCacheState } from './xux-dnd-cache.type';

export const INITIAL_XUX_DND_CACHE_STATE: XuxDndCacheState = {};

/**
 * This function updates dashboard cache state
 */
export const xuxDndCacheReducer: ActionReducer<XuxDndCacheState> = (
  state: XuxDndCacheState = INITIAL_XUX_DND_CACHE_STATE,
  action: IAction,
): XuxDndCacheState => {
  const { payload } = action;

  switch (action.type) {
    case XuxDndCacheActions.SET_CACHE_ITEM:
      return {
        ...state,
        [payload.key]: payload.value,
      };

    default:
      return { ...state };
  }
};
